import { useState } from "react";
import { C } from "../components/UI";

export default function Duvidas() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqSections = [
    {
      title: "Para usuárias",
      questions: [
        {
          q: "Como posso avaliar uma empresa?",
          a: "Você pode avaliar a empresa onde trabalha ou já trabalhou criando uma conta na WoMom. As avaliações ajudam outras mulheres a entender como é o ambiente de trabalho nas empresas."
        },
        {
          q: "As avaliações são anônimas?",
          a: "Sim. As avaliações são publicadas de forma anônima para garantir segurança e liberdade para compartilhar experiências reais."
        },
        {
          q: "Posso avaliar mais de uma empresa?",
          a: "Sim. Você pode avaliar todas as empresas onde já trabalhou."
        },
        {
          q: "Como encontrar vagas na plataforma?",
          a: "Na aba Vagas, você pode explorar oportunidades em empresas que valorizam diversidade e boas práticas no ambiente de trabalho."
        },
        {
          q: "Posso editar ou remover minha avaliação?",
          a: "Sim. Caso queira atualizar ou remover uma avaliação, você pode entrar em contato com nossa equipe."
        },
        {
          q: "As avaliações passam por aprovação?",
          a: "Sim, todas avaliações passam por aprovação, para que todas sigam as normas de boas práticas do site."
        }
      ]
    },
    {
      title: "Para empresas",
      questions: [
        {
          q: "Como cadastrar minha empresa na WoMom?",
          a: "Acesse a aba Para empresas e preencha o formulário de cadastro para criar a página da sua empresa na plataforma."
        },
        {
          q: "Minha empresa pode responder avaliações?",
          a: "Sim. Empresas cadastradas podem responder avaliações publicamente, demonstrando transparência e compromisso com melhorias."
        },
        {
          q: "Como divulgar vagas na WoMom?",
          a: "Empresas podem divulgar vagas diretamente na plataforma após realizar o cadastro."
        },
        {
          q: "Existem planos para empresas?",
          a: "Sim. A WoMom oferece planos corporativos para empresas que desejam fortalecer sua marca empregadora e atrair talentos femininos."
        }
      ]
    },
    {
      title: "Segurança e transparência",
      questions: [
        {
          q: "Como a WoMom garante avaliações confiáveis?",
          a: "Utilizamos regras de moderação para garantir que as avaliações sejam respeitosas e relacionadas à experiência de trabalho."
        },
        {
          q: "Posso denunciar uma avaliação inadequada?",
          a: "Sim. Caso encontre conteúdo inadequado, você pode denunciá-lo para que nossa equipe faça a análise."
        }
      ]
    },
    {
      title: "Contato",
      questions: [
        {
          q: "Não encontrei minha dúvida aqui. O que fazer?",
          a: "Entre em contato com nossa equipe através da página Contato."
        }
      ]
    }
  ];

  const toggleQuestion = (sectionIndex, questionIndex) => {
    const key = `${sectionIndex}-${questionIndex}`;
    setOpenIndex(openIndex === key ? null : key);
  };

  return (
    <main style={{ minHeight: "100vh", background: C.background }}>
      {/* Hero Section */}
      <section style={{ 
        background: C.roseMid,
        padding: "60px 20px",
        textAlign: "center"
      }}>
        <h1 style={{ 
          fontFamily: "'Playfair Display', serif",
          fontSize: 38,
          fontWeight: 700,
          color: "#fff",
          marginBottom: 12
        }}>
          Dúvidas frequentes
        </h1>
        <p style={{ 
          fontSize: 16,
          color: "rgba(255, 255, 255, 0.9)",
          maxWidth: 600,
          margin: "0 auto"
        }}>
          Encontre respostas sobre como usar a WoMom, avaliar empresas e divulgar vagas.
        </p>
      </section>

      {/* FAQ Content */}
      <section style={{ 
        maxWidth: 800,
        margin: "0 auto",
        padding: "60px 20px"
      }}>
        {faqSections.map((section, sectionIndex) => (
          <div key={sectionIndex} style={{ marginBottom: 40 }}>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 24,
              fontWeight: 700,
              color: C.roseMid,
              marginBottom: 20,
              paddingBottom: 10,
              borderBottom: `2px solid ${C.rosePale}`
            }}>
              {sectionIndex + 1}. {section.title}
            </h2>
            
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {section.questions.map((item, questionIndex) => {
                const key = `${sectionIndex}-${questionIndex}`;
                const isOpen = openIndex === key;
                
                return (
                  <div 
                    key={questionIndex}
                    style={{ 
                      background: C.surface,
                      borderRadius: 12,
                      border: `1px solid ${C.border}`,
                      overflow: "hidden"
                    }}
                  >
                    <button
                      onClick={() => toggleQuestion(sectionIndex, questionIndex)}
                      style={{
                        width: "100%",
                        padding: "16px 20px",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left"
                      }}
                    >
                      <span style={{ 
                        fontSize: 15,
                        fontWeight: 600,
                        color: C.textMain
                      }}>
                        {item.q}
                      </span>
                      <span style={{ 
                        fontSize: 20,
                        color: C.roseMid,
                        transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                        transition: "transform 0.2s ease"
                      }}>
                        +
                      </span>
                    </button>
                    
                    {isOpen && (
                      <div style={{ 
                        padding: "0 20px 16px 20px",
                        fontSize: 14,
                        color: C.textSec,
                        lineHeight: 1.7
                      }}>
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}
